import { create } from 'zustand'
import type { ContextGap } from '@/types/api'

export type { ContextGap }

export type AgentState = 'thinking' | 'extracting' | 'idle'

export interface StreamUpdate {
  id: string
  message: string
  timestamp: string
}

interface InterviewStreamState {
  updates: StreamUpdate[]
  gaps: ContextGap[]
  agentState: AgentState
  addUpdate: (message: string, timestamp?: string) => void
  setGaps: (gaps: ContextGap[]) => void
  setAgentState: (state: AgentState) => void
  reset: () => void
}

export const useInterviewStreamStore = create<InterviewStreamState>((set) => ({
  updates: [],
  gaps: [],
  agentState: 'idle',
  addUpdate: (message, timestamp) =>
    set((state) => ({
      updates: [
        {
          id: `update-${Date.now()}`,
          message,
          timestamp: timestamp || new Date().toISOString()
        },
        ...state.updates
      ].slice(0, 10)
    })),
  setGaps: (gaps) => set({ gaps }),
  setAgentState: (state) => set({ agentState: state }),
  reset: () => set({ updates: [], gaps: [], agentState: 'idle' })
}))
